import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { formatPrice } from 'modules/billing/lib/f25Prices'
import { capitalizeFirstLetter } from 'modules/onboarding/lib/pricing/plans/utils'
import { Currency, Tier } from 'modules/onboarding/lib/pricing/types'

export type OrderItem = {
  name: string
  isYearly: boolean
  isMainPlan: boolean
  perSeatPrice?: number
  feePrice?: number
  stairstepPrice?: number
  includedSeats?: number
  tieredPrice?: Tier[]
}

interface Props {
  seats: number
  currency: Currency
  countryFloor: number
}

const ItemInfo = ({
  name,
  isYearly,
  perSeatPrice,
  feePrice,
  seats,
  tieredPrice,
  stairstepPrice,
  isMainPlan,
  currency,
  countryFloor,
}: OrderItem & Props) => {
  const mainPlanPrice = perSeatPrice ? perSeatPrice * countryFloor : feePrice || stairstepPrice
  const price = perSeatPrice ? perSeatPrice * seats : feePrice || stairstepPrice
  const totalPrice = isMainPlan ? mainPlanPrice : price
  const yearlyPrice = totalPrice && totalPrice * 12
  // The first tier of a plan have a price per seat of 0. We can take the endingUnit of this tier to figure out the starting seats.
  const includedSeatsPerModule = tieredPrice?.[0]?.endingUnit
  // The next tier is where we can find the price per seat of all those seats above the "starting seats".
  const pricePerUser = tieredPrice?.[1]?.price || 0

  return (
    <Box gap="s2">
      <Box flexDirection="row" justifyContent="spaceBetween" gap="s12">
        <Text.Normal color="grey1000" weight="medium">
          {name}
        </Text.Normal>
        <Text.Normal color="grey1000" weight="medium" ellipsis>
          {formatPrice((isYearly ? yearlyPrice : totalPrice) || 0, currency)}
        </Text.Normal>
      </Box>
      {perSeatPrice ? (
        <Text.Normal size="200" color="grey700">
          {/* We do this to avoid showing the price per seat to selfserved companies */}
          {isMainPlan ? (
            <>{capitalizeFirstLetter(i18n.t('pricing_plans.fixed_fee'))}</>
          ) : (
            <>
              {formatPrice(perSeatPrice, currency)} {i18n.t('pricing_plans.per_employee_month')}
            </>
          )}
        </Text.Normal>
      ) : null}
      {feePrice ? (
        <Text.Normal size="200" color="grey700">
          {capitalizeFirstLetter(i18n.t('pricing_plans.fixed_fee'))}
          {includedSeatsPerModule && (
            <>
              {`, ${i18n.t('pricing_plans.employees_inludede', {
                employees: includedSeatsPerModule,
              })}`}
            </>
          )}
        </Text.Normal>
      ) : null}
      {stairstepPrice ? (
        <Text.Normal size="200" color="grey700">
          {capitalizeFirstLetter(i18n.t('pricing_plans.fixed_fee'))}
        </Text.Normal>
      ) : null}
      {tieredPrice ? (
        <Text.Normal size="200" color="grey700">
          {formatPrice(pricePerUser / 100, currency)} {i18n.t('pricing_plans.per_employee_month')}
        </Text.Normal>
      ) : null}
    </Box>
  )
}

export default ItemInfo
